import { createContext } from "react";

const TagsContext = createContext({});

export default TagsContext;
